import $ from 'jquery'
import async from 'async'
import _ from 'lodash'

let _p = window.xwCommon,
    _this = {
    	title:"门店复议",
    	name:"storeReviewWin",
    	initWin(vm){
    		//console.log(vm.info)
    		let order_id = vm.info.order_id, order_node_id = vm.info.order_node_id,
    			func = ( callback, reject ) => {
					async.waterfall([
						( next ) => {
							//console.log(info)
							let u = _p.getApiUrl("order/backlist")
				        	$.post(u,{order_node_id},(json) => {
					          let status = parseInt(json.status)
					          	if(200 !== status){
					            	switch(status){
					                    default: 
					                      if(_p.checkAjaxStatus(vm,json,_this.title)) break;
					                      //vm.$alert(json.msg,_this.title);
					                      next(json.msg)
					                      break;
					                }
					                return;
					          	}else{
					          		let data = json.data
					          		if(data.length > 0){
					          			vm.backNodeList = data
						            	return next(null)
					          		}else{
					          			return next("当前节点不支持回退操作！");
					          		}
						            
						        }
					        },"JSON")
						},
						( next ) => {
							vm.reviewForm = _this.getEmptyForm()
							vm.reviewForm["order_id"] = order_id
							vm.showDialog = true
						},
					],(err) => {
		            	if(err) return reject(err)
		           		else return callback()
		            })
				}

			return new Promise(func)
    	},
    	getEmptyForm(){
			return {
				"type":2,
				"advicePrice":0,
				"backNode":null,
				"mark":""
			}
		},
		submit(vm){
			let order_id = vm.info.order_id, order_node_id = vm.info.order_node_id,
				u = _p.getApiUrl("risk/storeReviev")
			vm.submitLoading = true
			async.waterfall([
				( next ) => {
					let form = _p.clone(vm.reviewForm)
					$.post(u,form,(json) => {
			        	let status = parseInt(json.status)
			          	if(200 !== status){
			            	switch(status){
			            		case 1002:
					                json.data.forEach((desc)=>{
					                  //console.log(desc)
					                  vm.$set(vm.customerBasicError, desc.name, desc.error)
					                })
					                break;
			                    default: 
			                      if(_p.checkAjaxStatus(vm,json,_this.title)) break;
			                      vm.$alert(json.msg,_this.title);
			                      break;
			                }
			                return;
			          	}else{
				            vm.$notify({title:_this.title,message:json.msg});
		            		next(null,form.type)
				        }
			        },"JSON")
				},
				( type, next ) => {
					switch(type){
						case 1:
							//console.log(vm.reviewForm)
							let arr = {
								order_node_id, 
								back_node_id:vm.reviewForm["backNode"], 
								last_msg:vm.reviewForm["mark"]
							}
							_this.sendBackTo(vm,arr).then(() => {
								next(null)
							}).catch((err) => next(err))
							break;
						case 2:
							
							_this.transition(vm,order_node_id).then(() => {
								next(null)
							}).catch((err) => next(err))
							break;
						case 3:
							next(null)
							break;
					}
				}
			],(err) => {
            	if(err){
            		vm.$alert(err.toString(),_this.title)
            		return;
            	}
           		else{
           			vm.submitLoading = false
           			vm.showDialog = false
           			vm.$bus.emit('reloadTodo')
           		}
            })
		},
		transition(vm,order_node_id){
			let u = _p.getApiUrl("order/transition"), func = ( callback, reject ) => {
				$.post(u,{order_node_id},(json) => {
		        	let status = parseInt(json.status)
		          	if(200 !== status){
		            	switch(status){
		                    default: 
			                    if(_p.checkAjaxStatus(vm,json,_this.title)) break;
			                    reject(new Error(json.msg));
			                    break;
		                }
		                return;
		          	}else{
			            //vm.$notify({title:_this.title,message:json.msg});
			            vm.$alert(json.msg,_this.title,{
			            	"callback":( action ) => {
			            		callback()
			            	}
			            })
			        }
		        },"JSON")
			}
			
			return new Promise(func)
		},
		sendBackTo(vm,data){
      		let u = _p.getApiUrl("order/back"), func = ( callback, reject ) => {
      			$.post(u,data,(json) => {
		        	let status = parseInt(json.status)
		          	if(200 !== status){
		            	switch(status){
		                    default: 
			                    if(_p.checkAjaxStatus(vm,json,_this.title)) break;
			                    reject(new Error(json.msg));
			                    break;
		                }
		                return;
		          	}else{
			            vm.$notify({title:_this.title,message:json.msg});
	            		callback()
			        }
		        },"JSON")
      		}
			return new Promise(func)
      	}
    }
export default _this


// WEBPACK FOOTER //
// ./src/lib/car/form/storeReviewWin.js